import React from 'react';
import { Link } from 'react-router-dom';

function MarketingFooter() {
  return (
    <footer className="marketing-footer">
      <div className="container">
        <div className="marketing-footer-grid">
          {/* Product */}
          <div className="marketing-footer-column">
            <h4>Product</h4>
            <ul>
              <li><Link to="/features">Features</Link></li>
              <li><Link to="/pricing">Pricing</Link></li>
              <li><Link to="/demo">Demo</Link></li>
            </ul>
          </div>

          {/* Company */}
          <div className="marketing-footer-column">
            <h4>Company</h4>
            <ul>
              <li><Link to="/contact">Contact Us</Link></li>
            </ul>
          </div>

          {/* Legal */}
          <div className="marketing-footer-column">
            <h4>Legal</h4>
            <ul>
              <li><Link to="/privacy">Privacy Policy</Link></li>
              <li><Link to="/terms">Terms of Service</Link></li>
            </ul>
          </div>

          {/* Connect */}
          <div className="marketing-footer-column">
            <h4>Get Started</h4>
            <ul>
              <li><Link to="/demo">Start Free Trial</Link></li>
              <li><a href="https://demo.deedstack.com" target="_blank" rel="noopener noreferrer">View Demo</a></li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="marketing-footer-bottom">
          <Link to="/" className="marketing-footer-logo">
            <img
              src="/images/deedstack-logos/logo-horizontal-final.svg"
              alt="DeedStack™"
            />
          </Link>
          <p>&copy; 2025 DeedStack&trade;. All rights reserved.</p>
          <p className="marketing-footer-tagline">Land Financing Software for Modern Investors</p>
        </div>
      </div>
    </footer>
  );
}

export default MarketingFooter;
